import styled from 'styled-components';

export const InsulatorElement = styled.div`
    user-select: auto;
    pointer-events: all;
`;

interface Props {
    children?: React.ReactNode;
}

export const NodeEventInsulator = (props: Props) => (
    <InsulatorElement
        onClick={e => {
            e.stopPropagation();
        }}
        // onDoubleClick={e => { e.stopPropagation(); }}
        onKeyDown={e => {
            e.stopPropagation();
        }}
        onPointerDown={e => {
            e.stopPropagation();
        }}
        onPointerUp={e => {
            e.stopPropagation();
        }}
        onMouseDown={e => {
            e.stopPropagation();
        }}
        onMouseUp={e => {
            e.stopPropagation();
        }}
    >
        {props.children}
    </InsulatorElement>
);
